import { Card, Stack, Typography, Button, Box, useTheme } from "@mui/material";
import React from "react";
import {
  Settings as TechnologyIcon,
  SportsEsports as GamingIcon,
  Science as ScienceIcon,
  MusicNote as MusicIcon,
  Diamond as LifestyleIcon,
  FitnessCenter as FitnessIcon,
} from "@mui/icons-material";
import { Link } from "react-router-dom";

const ExploreTopics = () => {
  const theme = useTheme();

  const topics = [
    {
      name: "Technology",
      icon: <TechnologyIcon />,
      color: "#7C3AED",
      bgColor: "rgba(124,58,237,0.1)",
    },
    {
      name: "Gaming",
      icon: <GamingIcon />,
      color: "#EC4899",
      bgColor: "rgba(236,72,153,0.1)",
    },
    {
      name: "Science",
      icon: <ScienceIcon />,
      color: "#F97316",
      bgColor: "rgba(249,115,22,0.1)",
    },
    {
      name: "Music",
      icon: <MusicIcon />,
      color: "#F59E0B",
      bgColor: "rgba(245,158,11,0.1)",
    },
    {
      name: "Lifestyle",
      icon: <LifestyleIcon />,
      color: "#3B82F6",
      bgColor: "rgba(59,130,246,0.1)",
    },
    {
      name: "Fitness",
      icon: <FitnessIcon />,
      color: "#10B981",
      bgColor: "rgba(16,185,129,0.1)",
    },
  ];

  return (
    <Card
      sx={{
        p: 2.5,
        borderRadius: "16px",
        boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
        backgroundColor: "white",
      }}
    >
      <Stack spacing={2}>
        <Typography
          variant="h6"
          sx={{
            fontWeight: 700,
            color: "text.primary",
          }}
        >
          Explore Topics
        </Typography>
        <Box
          sx={{
            display: "grid",
            gridTemplateColumns: "repeat(2, 1fr)",
            gap: 1.5,
          }}
        >
          {topics.map((topic) => (
            <Button
              key={topic.name}
              component={Link}
              to={`/search?query=${encodeURIComponent(topic.name)}`}
              sx={{
                borderRadius: "12px",
                p: 1.5,
                textTransform: "none",
                backgroundColor: topic.bgColor,
                color: topic.color,
                fontWeight: 600,
                display: "flex",
                flexDirection: "column",
                gap: 0.5,
                alignItems: "center",
                justifyContent: "center",
                minHeight: 80,
                "&:hover": {
                  backgroundColor: topic.bgColor,
                  transform: "translateY(-2px)",
                  boxShadow: `0 4px 12px ${topic.bgColor}`,
                },
                transition: "all 0.2s ease",
              }}
            >
              <Box sx={{ fontSize: "1.5rem" }}>{topic.icon}</Box>
              <Typography variant="body2" sx={{ fontWeight: 600 }}>
                {topic.name}
              </Typography>
            </Button>
          ))}
        </Box>
        <Button
          component={Link}
          to="/search"
          variant="text"
          sx={{
            textTransform: "none",
            color: "text.secondary",
            fontWeight: 500,
            mt: 1,
            "&:hover": {
              color: theme.palette.primary.main,
              backgroundColor: "transparent",
            },
          }}
        >
          Browse all
        </Button>
      </Stack>
    </Card>
  );
};

export default ExploreTopics;
